import React from "react";
import "./UserManagement.scss";
import UserListing from "components/userManagement/UserListing";
const UserManagement = () => {
  return (
    <>
      <UserListing />
    </>
  );
};
export default UserManagement;
